import type { App } from 'vue';
import type { Pinia } from 'pinia';

import { useCommissionsStore } from '~/stores/useCommissionsStore';
import { useCompanyStore } from '~/stores/useCompanyStore';
import { useEventStore } from '~/stores/useEventStore';
import { useInvoicesStore } from '~/stores/useInvoicesStore';
import { useOrdersStore } from '~/stores/useOrdersStore';
import { usePaymentSlipStore } from '~/stores/usePaymentSlipStore';
import { useProfileStore } from '~/stores/useProfileStore';
import { useRedemptionStore } from '~/stores/useRedemptionStore';
import { useTransactionsStore } from '~/stores/useTransactionsStore';
import { useCustomerPortfolioStore } from '~/stores/useCustomerServiceResponsibleStore';

export const eventPlugin = {
  install(app: App, pinia: Pinia) {
    const service = useEventStore(pinia);

    service.create(['OnSessionOpen', 'OnSessionClose', 'OnChangeEconomicGroup']);

    service.register({
      eventName: 'OnSessionOpen',
      callbacks: [
        useProfileStore(pinia).onSessionOpen,
        useCompanyStore(pinia).onSessionOpen,
        useCustomerPortfolioStore(pinia).onSessionOpen,
      ],
    });

    service.register({
      eventName: 'OnSessionClose',
      callbacks: [
        useProfileStore(pinia).onSessionClose,
        useCompanyStore(pinia).onSessionClose,
        useInvoicesStore(pinia).onSessionClose,
        useOrdersStore(pinia).onSessionClose,
        usePaymentSlipStore(pinia).onSessionClose,
        useCommissionsStore(pinia).onSessionClose,
        useRedemptionStore(pinia).onSessionClose,
        useTransactionsStore(pinia).onSessionClose,
      ],
    });

    service.register({
      eventName: 'OnChangeEconomicGroup',
      callbacks: [
        useInvoicesStore(pinia).onChangeEconomicGroup,
        useOrdersStore(pinia).onChangeEconomicGroup,
        usePaymentSlipStore(pinia).onChangeEconomicGroup,
        useCommissionsStore(pinia).onChangeEconomicGroup,
        useRedemptionStore(pinia).onChangeEconomicGroup,
        useTransactionsStore(pinia).onChangeEconomicGroup,
        useCustomerPortfolioStore(pinia).onChangeEconomicGroup,
      ],
    });

    app.provide('eventService', service);
    app.config.globalProperties.$eventService = service;
  },
};
